import { useEffect, useState } from "react";
import { Phone, Mail, Check, RotateCcw, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function MobileContacts() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("open");

  const load = () => api.get("/contact").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setHandled = async (id, handled) => {
    try { await api.put(`/contact/${id}/handled`, { handled }); toast.success(handled ? "Segnata come gestita" : "Riaperta"); load(); }
    catch { toast.error("Aggiornamento non riuscito"); }
  };

  const list = items.filter((c) => filter === "all" || (filter === "open" ? !c.handled : c.handled));
  const open = items.filter((c) => !c.handled).length;

  return (
    <div data-testid="mobile-contacts">
      <div className="flex items-center justify-between mb-3">
        <h1 className="font-serif text-2xl font-semibold text-[#0B2A45]">Richieste {open > 0 && <span className="text-sm bg-amber-100 text-amber-800 rounded-full px-2 py-0.5 align-middle" data-testid="mobile-contacts-open">{open} da gestire</span>}</h1>
        <button onClick={load} className="p-2 text-stone-500" data-testid="mobile-contacts-refresh"><RefreshCw className="w-5 h-5" /></button>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2 mb-3 -mx-4 px-4">
        {[["open", "Da gestire"], ["done", "Gestite"], ["all", "Tutte"]].map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)} data-testid={`mobile-contacts-filter-${v}`}
            className={`shrink-0 px-4 h-9 rounded-full text-sm font-semibold ${filter === v ? "bg-[#0F4C81] text-white" : "bg-white border border-stone-200 text-stone-600"}`}>{l}</button>
        ))}
      </div>

      <div className="space-y-3">
        {list.length === 0 && <p className="text-center text-stone-400 py-10">Nessuna richiesta</p>}
        {list.map((c) => (
          <div key={c.id} className={`bg-white rounded-2xl border p-4 ${c.handled ? "border-stone-200 opacity-70" : "border-amber-200"}`} data-testid={`mobile-contact-${c.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-semibold text-[#0B2A45] truncate">{c.name}{c.business && <span className="text-stone-500 font-normal"> · {c.business}</span>}</div>
                <div className="text-xs text-stone-500">{new Date(c.created_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</div>
              </div>
              {c.handled && <span className="text-xs font-semibold px-2 py-1 rounded-full bg-green-100 text-green-800 shrink-0">Gestita</span>}
            </div>
            <p className="text-sm text-stone-700 mt-3 whitespace-pre-wrap" data-testid={`mobile-contact-message-${c.id}`}>{c.message}</p>
            <div className="flex gap-2 mt-3 pt-3 border-t border-stone-100">
              {c.phone && <a href={`tel:${c.phone}`} className="flex-1 h-11 rounded-xl bg-stone-50 flex items-center justify-center text-stone-600" data-testid={`mobile-contact-call-${c.id}`}><Phone className="w-4 h-4" /></a>}
              <a href={`mailto:${c.email}?subject=Re: richiesta dal sito - Guatemalan Spirits`} className="flex-1 h-11 rounded-xl bg-stone-50 flex items-center justify-center text-[#0F4C81]" data-testid={`mobile-contact-mail-${c.id}`}><Mail className="w-4 h-4" /></a>
              {c.handled ? (
                <button onClick={() => setHandled(c.id, false)} className="flex-[2] h-11 rounded-xl bg-stone-50 text-stone-600 text-sm font-semibold flex items-center justify-center gap-1" data-testid={`mobile-contact-reopen-${c.id}`}><RotateCcw className="w-4 h-4" />Riapri</button>
              ) : (
                <button onClick={() => setHandled(c.id, true)} className="flex-[2] h-11 rounded-xl bg-[#15803D] text-white text-sm font-semibold flex items-center justify-center gap-1" data-testid={`mobile-contact-handled-${c.id}`}><Check className="w-4 h-4" />Gestita</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
